<template>
  <div>
    <tf-table
      v-if="isLoaded"
      v-bind="{
        filterValues: $route.query.filters,
        parentalControls: true,
        pageLimit: 100,
        tableData,
        tableMeta: {
          columns,
          sort: {
            direction: $route.query.sortDirection || 'asc',
            prop: $route.query.sortProp || 'type',
          }
        },
      }"
      @changeFilter="updateQueryParams('filters', $event)"
      @changeSortCriteria="changeSortCriteria"
    >
      <template
        v-if="error"
        #error
      >
        {{ error }}
      </template>
      <tf-table-parent-row
        :key="rowData.id"
        slot="parentRow"
        slot-scope="{ rowData }"
      >
        <tf-table-td>
          <router-link
            :to="{
              name: 'ProjectOverview',
              params: {
                projectId: rowData.id,
                view: 'product',
              }
            }"
          >
            <tf-button
              type="primary"
              size="text"
            >
              {{ rowData.type }}
            </tf-button>
          </router-link>
        </tf-table-td>
        <tf-table-td>
          <ul>
            <li
              v-for="product in rowData.products"
              :key="product"
              v-text="product"
            />
          </ul>
        </tf-table-td>
        <tf-table-td>
          {{ $TF.DatesUtils.formatSimpleDate(rowData.due_date, 'MM/DD/YY') || '&mdash;' }}
        </tf-table-td>
      </tf-table-parent-row>
    </tf-table>
    <router-view />
  </div>
</template>

<script>
  import RouterMixin from '@/mixins/router';
  import { getEmployerPlacementEvents } from '@/services/employer';

  /**
   * ClientHistory Page
   *
   * @vuedoc
   * @exports ClientHistory
   * @category Views
   */
  export default {
    name: 'CoverageHistory',
    mixins: [RouterMixin],
    props: {
      /**
       * The ID of the employer/client used to interact with the API.
       */
      clientId: {
        type: [String, Number],
        required: true,
      },
    },
    data: () => ({
      columns: [
        {
          filter: {
            type: 'string',
            width: '200px',
          },
          format: 'type',
          label: 'Event type',
          prop: 'type',
          sortable: true,
        },
        {
          format: 'products',
          label: 'Product(s)',
          prop: '25%',
        },
        {
          filter: {
            type: 'month',
            width: '200px',
          },
          format: 'date',
          label: 'Due date',
          prop: 'due_date',
          sortable: true,
        },
      ],
      error: null,
      isLoaded: false,
      tableData: [],
    }),
    created() {
      this.loadMarketingHistory();
    },
    methods: {
      /**
       * Load the marketing history and parse the data to pass to the table component.
       */
      async loadMarketingHistory() {
        try {
          const { completed_placement_events: tableData } = await getEmployerPlacementEvents(this.clientId, 'completed');
          const formattedData = tableData.map(({
            effective_date: effectiveDate,
            due_date: dueDate,
            id,
            products,
            type,
          }) => ({
            id,
            effective_date: effectiveDate,
            due_date: dueDate,
            type: type === 'Projects::RfpPlacementEvent'
              ? 'Full marketing'
              : 'Renewal collection',
            products: [
              ...new Set(products.map(({ product_type_name: name }) => name)),
            ].sort(),
          }));

          this.$set(this, 'tableData', formattedData);
        } catch (error) {
          this.error = 'There was an error retrieving Completed RFPs for this client.';
        } finally {
          this.isLoaded = true;
        }
      },
    },
  };
</script>
